import { useState, useEffect } from "react";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Главная", href: "#home" },
    { label: "О нас", href: "#about" },
    { label: "Условия", href: "#features" },
    { label: "Операторы", href: "#portfolio" },
    { label: "Блог", href: "#blog" },
    { label: "Контакты", href: "#contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm border-b border-primary-200/30"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        <a href="#home" className="flex items-center cursor-pointer font-bold text-xl text-foreground-950 gap-2">
          <i className="ri-briefcase-fill text-primary-500 text-2xl w-8 h-8 flex items-center justify-center" />
          <span>WorkTerra</span>
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="text-sm text-foreground-600 hover:text-primary-500 font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-4">
          <button className="text-sm text-foreground-600 hover:text-primary-500 font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap">
            Вакансии
          </button>
          <a
            href="#contact"
            className="inline-flex items-center px-5 py-2 rounded-full text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 shadow-md shadow-primary-500/20 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            380₽/час
          </a>
        </div>

        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2"
          aria-label="Меню"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <span
            className={`block w-6 h-0.5 bg-foreground-950 transition-all duration-300 ${
              mobileOpen ? "rotate-45 translate-y-2" : ""
            }`}
          />
          <span
            className={`block w-6 h-0.5 bg-foreground-950 transition-all duration-300 ${
              mobileOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block w-6 h-0.5 bg-foreground-950 transition-all duration-300 ${
              mobileOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/95 backdrop-blur-md border-b border-primary-200/30 px-6 pb-4">
          <ul className="flex flex-col gap-3 pt-2">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="block text-sm text-foreground-600 hover:text-primary-500 font-medium transition-colors py-1"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contact"
                onClick={() => setMobileOpen(false)}
                className="inline-flex items-center px-5 py-2 rounded-full text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 transition-colors mt-2"
              >
                380₽/час
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}